import { motion } from "framer-motion";
import { ArrowDown, Play } from "lucide-react";

const HERO_BG =
  "https://images.unsplash.com/photo-1664076458686-3449062080ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative min-h-[100svh] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F211A]/40 via-[#0F211A]/60 to-[#0F211A]" />
        <div className="absolute inset-0 bg-[#0F211A]/30" />
      </div>

      {/* Vertical labels left/right */}
      <div className="absolute left-6 top-1/2 -translate-y-1/2 hidden lg:block">
        <span className="vertical-label">EST · 2017 · NEW DELHI</span>
      </div>
      <div className="absolute right-6 top-1/2 -translate-y-1/2 hidden lg:block">
        <span className="vertical-label">FASHION · LIFESTYLE · BRAND FILMS · UGC</span>
      </div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12 pt-32 pb-24 min-h-[100svh] flex flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.2, ease: [0.6, 0.05, 0.05, 0.99] }}
          className="flex items-center gap-3 mb-8"
        >
          <span className="h-px w-12 bg-gold" />
          <span className="text-[11px] uppercase tracking-[0.4em] text-gold">
            High-end fashion & cinematic content
          </span>
        </motion.div>

        <h1
          className="font-display text-ivory text-[14vw] md:text-[10vw] lg:text-[8vw] leading-[0.9] tracking-tight max-w-[18ch]"
          data-testid="hero-title"
        >
          {"StyleePix".split("").map((ch, i) => (
            <motion.span
              key={`hero-char-${ch}-${i}`}
              initial={{ opacity: 0, y: 60 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 + i * 0.05, ease: [0.6, 0.05, 0.05, 0.99] }}
              className="inline-block"
            >
              {ch}
            </motion.span>
          ))}
          <br />
          <motion.span
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
            className="italic text-gold inline-block"
          >
            Collective.
          </motion.span>
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.2 }}
          className="mt-10 max-w-2xl text-ivory-muted text-base md:text-lg font-light leading-relaxed"
          data-testid="hero-subtitle"
        >
          A hybrid content agency turning fashion designers, product brands and influencers into
          cinematic experiences — through high-taste visuals, storytelling and intelligent
          creative technology.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.4 }}
          className="mt-12 flex flex-col sm:flex-row gap-4"
        >
          <button
            onClick={() => scrollTo("contact")}
            className="group inline-flex items-center justify-center gap-3 bg-gold text-forest hover:bg-gold-400 px-9 py-5 text-[11px] uppercase tracking-[0.35em] transition-colors"
            data-testid="hero-cta-primary"
          >
            Start a Project
            <span className="h-px w-6 bg-forest group-hover:w-10 transition-all" />
          </button>
          <button
            onClick={() => scrollTo("work")}
            className="group inline-flex items-center justify-center gap-3 border border-ivory/40 text-ivory hover:border-gold hover:text-gold px-9 py-5 text-[11px] uppercase tracking-[0.35em] transition-colors"
            data-testid="hero-cta-secondary"
          >
            <Play size={12} className="fill-current" />
            View Work
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.8, duration: 1 }}
          className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-ivory-muted"
        >
          <span className="text-[9px] tracking-[0.4em] uppercase">Scroll</span>
          <ArrowDown size={14} className="float-y text-gold" />
        </motion.div>
      </div>
    </section>
  );
}
